module.exports = __webpack_public_path__ + "static/media/CT_2019_30444A_pdf.9fba77ac.pdf";